import React from 'react'

export default function AdminCenter() {
  return (
    <div>AdminCenter</div>
  )
}
